<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="rubricLevel !== undefined" model="Rubric Level"></app-form-title>

	<app-rubric-dropdown-field
		[fg]="form"
		formGroupOrControlName="rubric_code"
		label="Rubric"
	></app-rubric-dropdown-field>

	<app-number-field [fg]="form" formGroupOrControlName="level" label="Level" [min]="0"></app-number-field>

	<app-text-field [fg]="form" formGroupOrControlName="name" label="Name"></app-text-field>

	<app-text-field [fg]="form" formGroupOrControlName="short_description" label="Short Description"></app-text-field>

	<div class="descriptions">
		<app-textarea-field
			[fg]="form"
			formGroupOrControlName="long_description"
			label="Long Description"
		></app-textarea-field>
		<app-textarea-field
			[fg]="form"
			formGroupOrControlName="prompt_description"
			label="Prompt Description"
		></app-textarea-field>
	</div>

	@for (skill of skills; track skill) {
		<div class="descriptions">
			<app-textarea-field
				[fg]="form"
				[formGroupOrControlName]="skill.code + '_description'"
				[label]="skill.label + ' Description'"
			></app-textarea-field>
			<app-textarea-field
				[fg]="form"
				[formGroupOrControlName]="skill.code + '_prompt_description'"
				[label]="skill.label + ' Prompt Description'"
			></app-textarea-field>
		</div>
	}

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
